import { render, staticRenderFns } from "./HomeUnidades.vue?vue&type=template&id=08d814eb&scoped=true&style=-webkit-animation%3A%20fadein%201s%3B%20-moz-animation%3A%20fadein%201s%3B%20-ms-animation%3A%20fadein%201s%3B%20-o-animation%3A%20fadein%201s%3B%20animation%3A%20fadein%201s%3B&"
import script from "./HomeUnidades.vue?vue&type=script&lang=js&"
export * from "./HomeUnidades.vue?vue&type=script&lang=js&"
import style0 from "./HomeUnidades.vue?vue&type=style&index=0&id=08d814eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d814eb",
  null
  
)

export default component.exports